const useRefreshToken = () => {
  /*   const { refreshToken } = useContext(UserContext); */
  /*   const laps = 10 * 60 * 1000; // 30 minutes */
  /*   useInterval(() => {
    refreshToken();
  }, laps); */
};

export default useRefreshToken;
